import { render } from "./AyudaMedicoAgenda.vue?vue&type=template&id=39a4389b&scoped=true"
import script from "./AyudaMedicoAgenda.vue?vue&type=script&lang=js"
export * from "./AyudaMedicoAgenda.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=39a4389b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a4389b"]])

export default __exports__